import SeccionLayout, { BloqueSeccion, PieGuardar } from "../SeccionLayout";
import { AYUDA_SECCION } from "@/components/ayuda/vistas/configuracion";
import { useAppSettings, useBorradorSeccion } from "../useAppSettings";

/**
 * Los dos datos de la casa: el nombre (etiquetas de la interfaz) y el correo de soporte
 * (contacto de respaldo en los tickets de Jimi).
 */
export default function DatosEmpresa() {
  const { settings, cargando, guardando, guardar } = useAppSettings();
  const { valores, set, sucio } = useBorradorSeccion(settings, (s) => ({
    nombre_empresa: s.nombre_empresa,
    soporte_email: s.soporte_email,
  }));

  if (cargando || !valores) {
    return <p className="text-sm text-zinc-500">Cargando…</p>;
  }

  const nombreVacio = valores.nombre_empresa.trim().length === 0;

  return (
    <SeccionLayout
      ayuda={AYUDA_SECCION["empresa"]}
      ancho="formulario"
      titulo="Datos de la empresa"
      descripcion="Cómo se llama la casa en la interfaz y a quién escribirle cuando alguien no puede entrar."
    >
      <div className="card space-y-4">
        <BloqueSeccion
          titulo="Nombre de la empresa"
          descripcion="Se usa en las etiquetas de la interfaz; por ejemplo, el filtro de la lista de casos para los que tenemos nosotros."
        >
          <input
            type="text"
            value={valores.nombre_empresa}
            onChange={(e) => set({ nombre_empresa: e.target.value })}
            placeholder="Emprenet"
            maxLength={60}
            className="input w-full"
          />
        </BloqueSeccion>

        <BloqueSeccion
          titulo="Correo de soporte"
          descripcion="Correo de contacto que se manda en los tickets de Jimi cuando quien lo levanta no tiene configurado su correo de la empresa. Si todos lo tienen, puede quedar vacío."
        >
          <input
            type="email"
            value={valores.soporte_email}
            onChange={(e) => set({ soporte_email: e.target.value })}
            placeholder="soporte@tu-dominio.com"
            className="input w-full"
          />
        </BloqueSeccion>

        <PieGuardar
          sucio={sucio}
          guardando={guardando}
          error={nombreVacio ? "El nombre de la empresa no puede quedar vacío." : null}
          onGuardar={() => void guardar(valores, "Datos de la empresa guardados")}
        />
      </div>
    </SeccionLayout>
  );
}
